<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-08 18:20:40
-->
<template>
	<div class="mt-12 yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="创建时间">
				<el-date-picker
					v-model="freeOrderTime"
					type="daterange"
					@change="changeTimed"
					value-format="yyyy-MM-dd"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
				>
				</el-date-picker>
			</el-form-item>
			<el-form-item label="商品组名称">
				<el-input v-model="formData['group_name']" placeholder="请输入商品组名称"></el-input>
			</el-form-item>
			<el-form-item label="商品组ID">
				<el-input v-model="formData['id']" placeholder="请输入商品组ID"></el-input>
			</el-form-item>
			<el-form-item label="创建人">
				<el-select v-model="formData['user_id']" clearable placeholder="创建人角色">
					<el-option :label="item.partner_name" :value="item.id" v-for="(item, index) in createArr" :key="index">
						<div class="flex flex-align-center">
							<span class="mr-8">{{ item.partner_name }}</span>
							<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
							<el-tag v-else-if="item.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
						</div>
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="推广状态">
				<el-select v-model="formData['group_status']" clearable placeholder="请选择推广状态">
					<el-option :label="item.label" :value="item.value" v-for="(item, index) in promoteText" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { creatUserList } from '@/api/shopManage';
import { roleSelectOptions } from '@/utils/dataMap';
import throttle from 'lodash/throttle';
export default {
	name: 'search',
	components: {},
	data() {
		return {
			formData: {},
			freeOrderTime: '',
			promoteText: [
				{
					label: '关闭推广',
					value: '0',
				},
				{
					label: '推广中',
					value: '1',
				},
			],
			roleIdArr: roleSelectOptions,
			createArr: [],
		};
	},
	created() {
		this.getCreateList();
	},
	methods: {
		async getCreateList() {
			const { code, data } = await creatUserList({});
			if (code == 0) {
				this.createArr = data;
        // 将数组分成三个部分
        const notUseStatus2AndNotDeleted = this.createArr.filter(item => item.use_status !== '2' && !item.deleted);
        const useStatus2 = this.createArr.filter(item => item.use_status === '2');
        const deleted = this.createArr.filter(item => item.deleted);
        // 合并三个部分
        this.createArr = [...notUseStatus2AndNotDeleted, ...useStatus2, ...deleted];
			}
		},
		onClear() {
			this.formData = {};
			this.freeOrderTime = '';
			this.onSubmit();
		},
		changeTimed(value) {
			const [start, end] = value || [];
			this.formData.from_time = start ? Date.parse(start) / 1000 - 8 * 3600 : '';
			this.formData.to_time = end ? Date.parse(end) / 1000 + 16 * 3600 - 1 : '';
		},
		onSubmit: throttle(function() {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>

<style lang="less" scoped></style>
